<template>
    <div>
        <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
        <div class="container py-2" :style="leagueData.length>0 ? 'heght: auto' : 'height: calc(100vh - 129px);'">
            <div class="d-flex justify-content-between my-3" :class="isMobile ? 'flex-column' : ''">
                <div :class="isMobile ? 'flex-column align-items-start' : 'align-items-center'" class="d-flex">
                    <h1 class="fs-18" :class="isMobile ? '' : 'me-4 mb-0'">联赛数据查看:</h1>
                    <!-- <el-dropdown trigger="click" @command="selectLg" class="text-primary">
                        <span class="el-dropdown-link">
                            {{ this.selectName }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="d-menu">
                            <el-dropdown-item v-for="(item,index) in leagueList" :key="index" :command="{id:item.id,name:item.name}">{{ item.name }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                    <el-autocomplete
                    class="inline-input"
                    v-model="state"
                    :fetch-suggestions="querySearch"
                    :clearable = true
                    placeholder="请输入内容"
                    @select="selectLg"
                    ></el-autocomplete>
                </div>
                <div :class="isMobile ? 'mt-2' : ''">
                    <el-radio v-model="radio" label="fb" @input="changeType">足球</el-radio>
                    <el-radio v-model="radio" label="bb" @input="changeType">篮球</el-radio>
                </div>
            </div>
            <div class="mb-4">
                <div class="mb-4 d-flex">
                    <div class="my-2 d-flex align-items-center">
                        <b>主队：</b>
                        <el-autocomplete
                        class="inline-input"
                        v-model="teamStateH"
                        :fetch-suggestions="teamSearch"
                        :clearable = true
                        placeholder="选择球队"
                        @select="selectTmh"
                        ></el-autocomplete>
                         <input v-model="hxg" type="text" class="form-control border-0 bg-transparent" placeholder="xg" style="width: 80px;" disabled>
                         <!-- <span>{{ hatr }},{{ hdef }}</span> -->
                    </div>
                    <div class="my-2 d-flex align-items-center">
                        <b>客队：</b>
                        <el-autocomplete
                        class="inline-input"
                        v-model="teamStateA"
                        :fetch-suggestions="teamSearch"
                        :clearable = true
                        placeholder="选择球队"
                        @select="selectTma"
                        ></el-autocomplete>
                        <input v-model="axg" type="text" class="form-control border-0 bg-transparent w-25" placeholder="xg" style="width: 80px;" disabled>
                        <!-- <span>{{ aatr }},{{ adef }}</span> -->
                    </div>
                    <div class="my-2 d-flex align-items-center">
                        <b class="me-2">实力差:</b>
                        <input v-model="qsda" type="text" class="form-control border-0 bg-transparent" placeholder="--" style="width: 80px;" disabled>
                    </div>
                    <div class="my-2 d-flex align-items-center">
                        <b class="me-2">大小球:</b>
                        <input v-model="bs" type="text" class="form-control border-0 bg-transparent" placeholder="--" style="width: 80px;" disabled>
                    </div>
                </div><!--计算xg-->
                <ux-grid
                ref="plxTable"
                stripe
                show-overflow
                use-virtual
                :data = leagueData
                :highlightCurrentRow="true"
                :checkboxConfig="{highlight: true}"
                :edit-config="{trigger: 'click', mode: 'cell'}">
                <!-- <ux-table-column type="checkbox" :width="40"/> -->
                <ux-table-column type="index" :width="40"/>
                <ux-table-column field="tid" title="球队id" :width="80"></ux-table-column>
                <ux-table-column field="tname" title="球队名" :width="isMobile ? 180 : ''"></ux-table-column>
                <ux-table-column field="mNum" title="总" :width="80"></ux-table-column>
                <ux-table-column field="totalGet" title="得" :width="80"></ux-table-column>
                <ux-table-column field="totalLoss" title="失" :width="80"></ux-table-column>
                <ux-table-column field="eqGet" title="均得" :width="80"></ux-table-column>
                <ux-table-column field="eqLoss" title="均失" :width="80"></ux-table-column>
                <ux-table-column field="lg_avg_get" title="联赛均得" :width="80"></ux-table-column>
                <ux-table-column field="atr" title="进攻系数" :width="80"></ux-table-column>
                <ux-table-column field="def" title="防守系数" :width="80"></ux-table-column>
                </ux-grid><!--球队数据表格-->
            </div>
            <!-- <div class="bottom-btn w-100 text-end py-2">
            <el-button @click="insertEvent(-1)">新增联赛</el-button>
            <el-button @click="saveChg">保存修改</el-button>
            </div> -->
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Nav from '../comment/nav.vue'
import Footer from '../comment/footer.vue'
import { searchLgByCnameUrl, createLeagueUrl, updateLeagueUrl, getFbLgListUrl, getBbLgListUrl, getFbLgDataUrl, getBbLgDataUrl } from '../../constants/http.config'
import { checkDevice, qsdaBbVal, fbBsVal } from '../../utils/utils'

export default {
    components: { Nav,Footer },
    data(){
        return {
            isDark: false,
            input: '',
            leagueList: [],
            drawdownList: [],
            teamsList: [],
            drawdownTeamList: [],
            leagueData: [],
            filters: [],
            loading: false,
            isMobile: false,
            selectName: '选择联赛',
            radio: 'fb',
            state: '',
            teamStateH: '',
            teamStateA: '',
            hatr: 0,
            aatr: 0,
            hdef: 0,
            adef: 0,
            hxg: 0,
            axg: 0,
            lg_avg: 0,
            qsda: '',
            bs: ''
        }
    },
    mounted() {
        this.getLgData();
        this.isMobile = checkDevice();        
    },
    methods: {
        checkDevice,
        qsdaBbVal,
        fbBsVal,
        getLgData(){
            let url = '';
            if (this.radio === 'fb') {
                url = getFbLgListUrl;
            }else{
                url = getBbLgListUrl;
            }
            fetch(url)
            .then(response => response.json())
            .then(data => {
                console.log(data.data);
                this.leagueList = data.data;
                for (let index = 0; index < data.data.length; index++) {
                    const elm = data.data[index];
                    this.drawdownList.push({
                        value: elm.name,
                        id: elm.id,
                    })
                }
                
            }).catch(err=>{
                console.log(err);
            })
        },
        removeSelected(row){
            // console.log(row);
            this.$refs.plxTable.remove(row)
        },
        async insertEvent (row) {
            // console.log(row);
            let record = {
                name: '联赛名',
                id: 'id',
                iscup: false,
            }
            // 加入行, 表示加入行的row对象，row为空则插入第一行，为-1插入最后一行
            let { row: newRow } = await this.$refs.plxTable.insertRow(record, row)
            // 激活单元格编辑
            await this.$refs.plxTable.setActiveRow(newRow)
        },
        async updateLeague(url,chgData){
            fetch(url,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(chgData)
                    })
                    .then(response => response.json());
        },
        async saveChg(){
            const chgData = this.$refs.plxTable.getTableData().tableData;
            chgData.map(obj => {
                delete obj._XID;
                delete obj.detail;
                return obj;
            });
            console.log(chgData);
            const url = '/basketball/league/change-list';
            fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(chgData)
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.msg === 'success') {
                    //弹出成功提示
                    this.$alert('更新数据成功！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                }else{
                    //弹出失败提示
                    this.$alert('更新数据出错！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                }
            })
            .catch(error => {
                console.error('Error:', error);
                //弹出失败提示
                this.$alert('未知错误！更新数据失败！', '', {
                        confirmButtonText: '确定',
                });
            });
        },
        async saveChange(){
            const res = this.$refs.plxTable.getCheckboxRecords();
            console.log(res);
            
            // if (res.length === 0) {
            //     console.log(0);
            //     this.$message({
            //         showClose: true,
            //         type: 'warning',
            //         message: '请选中至少一条数据!'
            //     });
            // }else{
            //     // console.log(res);
            //     let countSuccess = 0;
            //     let countFail = 0;
            //     const requests = [];
            //     for (let index = 0; index < res.length; index++) {
            //         const chgData = res[index];
            //         // const url = '/league/update';
            //         const request = fetch(updateLeagueUrl,{
            //             method: 'POST',
            //             headers: {
            //                 'Content-Type': 'application/json'
            //             },
            //             body: JSON.stringify(chgData)
            //         })
            //         .then(response => response.json())
            //         .then(data => {
            //             console.log(data);
            //             if (data.msg == 'success') {
            //                 countSuccess++;
            //             }else{
            //                 countFail++;
            //             }
            //         }).catch(error => {
            //             console.error('Error:', error);
            //         });
            //         requests.push(request);        
            //     }
            //     Promise.all(requests).then(() => {
            //         this.$notify.info({
            //             title: '消息',
            //             message: `更新${countSuccess}条成功，${countFail}条失败`
            //         });
            //     }).catch(error => {
            //         console.error('Error:', error);
            //     });
            // }
        },
        onSubmit(formName){
            // console.log(this.form);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$message.error('添加的id、国家、态况名、捷报名不能为空!');
                    // const url = '/league/create';
                    fetch(createLeagueUrl,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(this.form)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if (data.msg == 'success') {
                            this.$notify({
                                title: '成功',
                                message: '添加联赛成功，' + data.data,
                                type: 'success'
                            });
                        }else{
                            this.$notify.error({
                                title: '失败',
                                message: data.data
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        this.$notify.error({
                            title: '错误',
                            message: '添加联赛出错'
                        });
                    });
                } else {
                    this.$message.error('添加的id、联赛名不能为空!');
                }
            })
        },
        selectTmh(command){
            console.log(command);
            for (let index = 0; index < this.teamsList.length; index++) {
                const elm = this.teamsList[index];
                if (command.id === elm.tid) {
                    // console.log('1111',elm.atr,elm.def);
                    this.hatr=elm.atr;
                    this.hdef=elm.def;
                    this.lg_avg = elm.lg_avg_get;
                }
            }
            this.calculateXg();
        },
        selectTma(command){
            console.log(command);
            for (let index = 0; index < this.teamsList.length; index++) {
                const elm = this.teamsList[index];
                if (command.id === elm.tid) {
                    // console.log('2222',elm.atr,elm.def);
                    this.aatr=elm.atr;
                    this.adef=elm.def;
                    this.lg_avg = elm.lg_avg_get;
                }
            }
            this.calculateXg();
        },
        selectLg(command){
            let url = ''
            if (this.radio == 'fb') {
                url = getFbLgDataUrl + command.id;
            }else{
                url = getBbLgDataUrl + command.id;
            }
            this.selectName = command.name
            fetch(url)
            .then(response => response.json())
            .then(data => {
                    console.log(data.data[0].thisSeason);
                    if (data.code == 200) {
                        this.drawdownTeamList = [];
                        if (data.data[0].mergeSeason.length>0) {
                            this.leagueData = data.data[0].mergeSeason;
                            for (let index = 0; index < this.leagueData.length; index++) {
                                const elm = this.leagueData[index];
                                this.teamsList.push(elm);
                                this.drawdownTeamList.push({
                                    value: elm.tname,
                                    id: elm.tid
                                });
                            }
                        }else{
                            this.leagueData = data.data[0].thisSeason;
                            for (let index = 0; index < this.leagueData.length; index++) {
                                const elm = this.leagueData[index];
                                this.teamsList.push(elm);
                                this.drawdownTeamList.push({
                                    value: elm.tname,
                                    id: elm.tid
                                });
                            }
                        }
                        if (this.leagueData.length == 0) {
                            this.emptyText = '暂无数据';
                        }else{
                            this.emptyText = '加载中...';
                        }
                        this.$refs.plxTable.reloadData(this.leagueData);
                        // this.updateFilterEvent()
                        this.loading = false;
                    }else{
                        this.emptyText = '暂无数据';
                        this.loading = false;
                    }
            })
            .catch(error => {
                console.error('Error:', error)
                this.emptyText = '暂无数据';
                this.loading = false;
            });
        },
        changeType(){
            this.leagueList = [];
            this.drawdownList = [];
            this.leagueData = [];
            this.drawdownTeamList = [];
            this.state = '';
            this.teamStateH = '';
            this.teamStateA = '';
            this.qsda = '';
            this.hxg = 0;
            this.axg = 0;
            this.hatr = 0;
            this.aatr = 0;
            this.hdef = 0;
            this.adef = 0;
            this.lg_avg =0;
            this.getLgData();
        },
        querySearch(queryString, cb) {
            var leagueList = this.drawdownList;
            // console.log('0000',leagueList);
            var results = queryString ? leagueList.filter(this.createFilter(queryString)) : leagueList;
            // console.log('1111',results);
            
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        teamSearch(queryString, cb) {
            var teamsList = this.drawdownTeamList;
            // console.log('0000',teamsList);
            var results = queryString ? teamsList.filter(this.createFilter(queryString)) : teamsList;
            // console.log('1111',results);
            
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (leagueList) => {
                return (leagueList.value.indexOf(queryString) !== -1);
            };
        },
        calculateXg(){
            // console.log('7777');
            if (this.hatr!==0 && this.hdef!==0 && this.aatr!==0 && this.adef!==0) {
                this.hxg = Math.round(this.hatr * this.adef * this.lg_avg * 100) / 100;
                this.axg = Math.round(this.aatr * this.hdef * this.lg_avg * 100) / 100;
                if (this.radio === 'bb') {
                    // this.qsda = Math.round(this.hxg - this.axg * 100) / 100;
                    this.qsda = this.qsdaBbVal(this.hxg - this.axg);
                    this.bs = this.fbBsVal(this.hxg + this.axg);
                }else{
                    this.qsda = Math.round((this.hxg - this.axg) * 100);
                    this.bs = this.fbBsVal(this.hxg + this.axg);
                }
                
                console.log('88888',this.hxg-this.axg);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/sass/global.scss';
    .d-menu {max-height: 300px; overflow-y: scroll;}
</style>